import React from 'react';
import PropTypes from 'prop-types';

const ExportXLSX = (
    {
        disabled,
        isLoading,
        onExport
    }) => {

    return (
        <button disabled={!!disabled}
            className={`flex items-center justify-center shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  transition duration-150 ease-in-out 
        rounded  px-4 py-2 text-sm ${disabled ? 'bg-gray-200 text-gray-400' : 'text-white bg-green-600 focus:ring-green-700 hover:bg-green-600'}`}
            onClick={onExport}
        >
            <svg className="w-4 h-4 pr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" /></svg> Export

        </button>
    );
}





ExportXLSX.propTypes = {
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onExport: PropTypes.func.isRequired,
};

export default ExportXLSX;


